import { Injectable } from '@angular/core';
import { ApiService } from '../..';
@Injectable()
export class BaocaoloadprofileService {
  constructor(public api: ApiService) {
  }
  APIURL_Chung = "api/ExcuteOracle"
  //Lấy báo cáo thống kê
  public P_Laybaocaoloadprofile(mataikhoan, danhmucid, ngay, type, sotrang, sodong) {
    var param = {
      config: JSON.stringify({ namesql: "PKB_BC_CSC_LOADPROFILE.P_LAY_BC_LOADPROFILE" }),
      para: JSON.stringify({
        v_mataikhoan: mataikhoan,
        v_danhmucid: danhmucid,
        v_Date: ngay,
        v_Type: type,
        v_sotrang: sotrang,
        v_sodong: sodong
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }  
  Laybaocaoloadprofile_EXCEL(mataikhoan, danhmucid, ngay, type, sotrang, sodong, tenDanhmuc, filename) {
    let cols = [];
    cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "tennhamay", "label": "Tên nhà máy", "horizontalalignment": "left" },
      { "name": "tenkhachhang", "label": "Tên điểm đo", "horizontalalignment": "left" },
      { "name": "socongto", "label": "ID công tơ", "horizontalalignment": "left" },
      { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
      { "name": "status", "label": "Tình trạng", "horizontalalignment": "left" },
      { "name": "slthieu", "label": "Số chu kỳ thiếu", "horizontalalignment": "right" },
      { "name": "tong", "label": "Tổng điểm đo", "horizontalalignment": "center" },
      { "name": "du", "label": "Điểm đo đủ chu kỳ", "horizontalalignment": "center" },
      { "name": "thieu", "label": "Điểm đo thiếu chu kỳ", "horizontalalignment": "center" },
      { "name": "khongco", "label": "Điểm đo thiếu toàn bộ chu kỳ", "horizontalalignment": "center" },
    ]

    //let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKB_BC_CSC_LOADPROFILE.P_LAY_BC_LOADPROFILE" }),
      para: JSON.stringify({
        v_mataikhoan: mataikhoan,
        v_danhmucid: danhmucid,
        v_Date: ngay,
        v_Type: type,
        v_sotrang: sotrang,
        v_sodong: sodong
      }),
      title: "BÁO CÁO TỔNG HỢP THU THẬP 48 CHU KỲ THEO NGÀY," + "THÔNG TIN CHI TIẾT ĐIỂM ĐO",
      header: tenDanhmuc+" - Ngày: " + ngay + "," + tenDanhmuc+" - Ngày: " + ngay,
      filename: filename,
      sheets: "BÁO CÁO TỔNG HỢP THU THẬP 48 CHU KỲ THEO NGÀY," + "THÔNG TIN CHI TIẾT ĐIỂM ĐO",
      columns: cols,
      data: ""
    };

    return this.api.downloadFile("api/ExportExcel", param, filename);
  }  
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/bao-cao/bao-cao-loadprofile/baocaoloadprofile.service.ts